(ns dashboard.db)

(def empty-upload-state
  {:upload-status :pending
   ;; :files is a map where file name is the key and the value is a map with
   ;;  * :file js/File
   ;;  * :upload-status #{:pending :completed :failed}
   :files         {}})

(def default-db
  {:ui                 {:show-menu?  false
                        :error       nil
                        :initialized false
                        :modal       nil}
   :route              nil
   :upload             {:policies       empty-upload-state
                        :questionnaires empty-upload-state}
   :user               {:roles #{"anonymous"}}
   :workbook-workspace {:context-menu {:is-visible? false}
                        :browser      {:size        2
                                       :is-visible? true
                                       :path        [{:path-type :root
                                                      :title     "Workbooks"}]
                                       :workbooks   []}
                        :grid         {:help {:is-visible? false}}
                        :workbooks    {}}})
